import { createContext, useContext, useState } from "react";
import { getPwsIdCookie } from "../../utilities/commonFunctions/pwsIdCookie";

const ModalContext = createContext();

export const WaterSystemSearchModalProvider = ({ children }) => {
  const [showSystemSelectModal, setShowSystemSelectModal] = useState(false);
  const [selectedWaterSystem, setSelectedWaterSystem] = useState(
    sessionStorage.getItem("selectedWaterSystem")
      ? JSON.parse(sessionStorage.getItem("selectedWaterSystem"))
      : null
  );
  const [isRestoringFromCookie, setIsRestoringFromCookie] = useState(
    !sessionStorage.getItem("selectedWaterSystem") && !!getPwsIdCookie()
  );

  return (
    <ModalContext.Provider value={{ showSystemSelectModal, setShowSystemSelectModal, selectedWaterSystem, setSelectedWaterSystem, isRestoringFromCookie, setIsRestoringFromCookie }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useWaterSystemSearchModal = () => useContext(ModalContext);